import { Input } from '@/components/ui/input';
import type { ControlProps } from './types';

/** Free text. */
export function TextControl({ id, value, onChange, disabled, invalid, describedBy }: ControlProps) {
  return (
    <Input
      id={id}
      type="text"
      value={typeof value === 'string' ? value : value == null ? '' : String(value)}
      disabled={disabled}
      aria-invalid={invalid || undefined}
      aria-describedby={describedBy}
      onChange={(e) => onChange(e.target.value)}
      className="h-8"
    />
  );
}
